/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_21912252"]'><div><cube-button @_click="showPicker">async-cascade-picker</cube-button><cube-cascade-picker-modal ref="__mpx_ref_asyncPicker__" :title="('标题')" :list="(dataList)" :selectedIndex="(selectedIndex)" :async="(true)" @columnChange='(e)=>__invoke(e, [["onColumnChange"]])' @confirm='(e)=>__invoke(e, [["onConfirm"]])'/><div :class='["event-params","m-t-10"]'><div :class='["desc-text","m-t-10","m-b-10"]'>因设置 async 为true，change 事件会在用户更新数据后才相应；例子里第二例滚动时没有更新数据，所以无法点击确认</div><template v-if="(changeParams)"><div :class='["m-b-10"]'>change 事件参数：</div><div :class='["value","m-b-10"]'><div view v-for="(item, index) in (changeParams)" :key="item.index" :class='["value-item"]'><div :class='["item-key"]'>{{item[0]}}</div><div :class='["item-value"]'>{{item[1]}}</div></div></div></template></div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_21912252"}'>
.picker-demo-title
  margin-bottom: 8px
.event-params,
.demo-data
  margin-top: 10px
  .key
    margin-bottom: 10px
  .value
    margin-bottom: 20px
    white-space: break-spaces
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_21912252"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_21912252"}
  /** script content **/
  require("./async-picker.mpx.js?isComponent&outputPath=components%2Fasync-picker21912252%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./async-picker.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fasync-picker21912252%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_21912252"],
    ctorType: "component",
    outputPath: "components/async-picker21912252/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-cascade-picker-modal':getComponent(require("../../../packages/mpx-cube-ui/src/components/cascade-picker-modal/index.mpx?isComponent&outputPath=components%2Findex0361f5ae%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>